import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How can I launch an app in the UAE?",
    answer: `<p>You can develop an app by yourself and launch it, hire an app development team to get your app developed, or you can outsource your app development to TekRevol, which is the pioneer in delivering exceptional mobile applications to businesses.</p>
        <p>Here are some of the reasons why you would want to hire TekRevol as your app development company in Dubai:</p> 
        <ul>
        <li>Years of experience and expertise</li>
        <li>Considered the top app development company</li>
        <li>Validates your product ideas</li>
        <li>Develops your applications efficiently</li>
        <li>Stay ahead of the curve with advanced technologies</li>
        <li>Timely project completion and delivery</li>
        <li>Multiple engagement models</li>
        <li>Assistance 24/7</li>
    </ul>`,
  },
  {
    question: "How much time is required to build a mobile application?",
    answer: `<p>It depends on the functionality, features, UI/UX, complexity, and overall requirements of the client. On average, the mobile application development process can take from 3 to 12 months. However, the time duration can increase if advanced features need to be implemented or iterations or changes are made to the application during development.</p>`,
  },
  {
    question: "How much does it cost to create an app in Dubai?",
    answer: `<p>We have a detailed breakdown of how much it cost to create an app, and if you want to see the factors that influence your mobile app's development, you can visit the article. Moreover, the cost of app development varies on the type of the app, complexity, features, technology stack, and more. If you want to see how much your app would cost in the UAE, reach out to our app development expert to get an estimate of your app.</p>`,
  },
  {
    question:
      "What is a mobile app support service, and does TekRevol offer it?",
    answer: `<p>Mobile app support service is the process of ensuring that your app stays up to date on the Google Play Store and App Store. TekRevol's app developers in Dubai offer post-deployment app support and maintenance services to keep your application up and running smoothly. However, this is not a complimentary service and is subject to change as per the terms of our agreement.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>

          {/* <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DubaiPin}</div>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
